import LoginPage from '../components/login/LoginPage';
import AutoLoginPage from '../components/auto-login/AutoLoginPage';
import ForgotPasswordPage from '../components/forgot-password/ForgotPasswordPage';
import ResetPasswordPage from '../components/reset-password/ResetPasswordPage';
import UserRegistrationPage from '../components/user-registration/UserRegistrationPage';
import DocPage from "../components/documentation/DocPage";
import BlankPage from '../components/blank/BlankPage';



// ======================================================================
// COMMON routes (routes for both PRO and PATHFINDER).
// ======================================================================

let commonRoutes = [
    {
        path: '/',
        name: 'LoginPage',
        component: LoginPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/auto-login',
        name: 'AutoLoginPage',
        component: AutoLoginPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPasswordPage',
        component: ForgotPasswordPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/reset-password',
        name: 'ResetPasswordPage',
        component: ResetPasswordPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/user-registration',
        name: 'UserRegistrationPage',
        component: UserRegistrationPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/docs',
        name: 'DocPage',
        component: DocPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/blank',
        name: 'BlankPage',
        component: BlankPage,
        meta: {
            forVisitors: true
        }
    }
];


export default commonRoutes;



// WEBPACK FOOTER //
// ./src/common/router/routes-common.js